export enum VCLossTypes {
  RESIDENTIAL = 'residential',
  COMMERCIAL = 'commercial',
  OTHER = 'other',
}

export const VC_LOSS_OPTIONS = [
  { value: VCLossTypes.RESIDENTIAL, label: 'Residential' },
  { value: VCLossTypes.COMMERCIAL, label: 'Commercial' },
  { value: VCLossTypes.OTHER, label: 'Other' },
];

export const RENT_ROLL_LABELS = {
  NUMBER_OF_COMMERCIAL_UNITS: 'Number of Commercial Units',
  NUMBER_OF_RESIDENTIAL_UNITS: 'Number of Residential Units',
  BATHROOMS: 'Bathrooms',
  OUTDOOR_SPACE: 'Outdoor Space',
  UNIT_LAYOUT: 'Unit Type',
  UNIT_NUMBER: 'Unit Number',
  BEDROOMS: 'Bedrooms',
  SQUARE_FOOTAGE: 'Square Feet',
  RENT_TYPE: 'Rent Type',
  BORROWER_MONTHLY_RENT: 'Borrower Rent',
  PROJECTED_MONTHLY_RENT: 'Projected Rent',
  ANNUAL_RENT: 'Annual Rent',
  RENT_PER_SF: 'Rent PSF',
  LEASE_STATUS: 'Lease Status',
  USE: 'Use',
  TENANT: 'Tenant',
};
